// extracted by mini-css-extract-plugin
export default {"container":"login-message_container__T0kMQ","textarea":"login-message_textarea__PrD1R","footer":"login-message_footer__Upmsf"};